<template>
  <div class="small-4 medium-4 large-4 columns logos">
    <a class="logoitem">
      <img :src="src" />
    </a>
  </div>
</template>

<script>
export default {
  props: ["src"],
  setup() {


    return {}
  }
}
</script>

<style lang="scss" scoped>
img {
  height: 70px;
}

.logos {
  display: flex;
  justify-content: center;
}

.logos:first-of-type img {
  height: 105px;
  padding-top: 20px;
}

.logos:nth-child(2) img {
  height: 90px;
  padding-top: 30px;
}

.logos:last-of-type img {
  height: 130px;
}


@media (max-width: 1280px) {

  .logos:first-of-type img {
    height: 90px;
    padding-top: 20px;
  }

  .logos:nth-child(2) img {
    height: 80px;
    padding-top: 30px;
  }

  .logos:last-of-type img {
    height: 100px;
    padding-top: 12px;
  }
}

@media (max-width: 767px) {
  .logos:first-of-type img {
    height: 55px;
    padding-top: 15px;
  }

  .logos:nth-child(2) img {
    height: 53px;
    padding-top: 23px;
  }

  .logos:last-of-type img {
    height: 70px;
    padding-top: 10px;
  }

  .logos {
    padding-right: 0px;
    padding-left: 0px;
  }

}
</style>